import angular from 'angular';
import { importFilesUnderPath, templateCacheGenerator } from 'roblox-es6-migration-helper';

import "../../../css/verifyEmail/verifyEmail.scss";

//import main module definition.
import verifyEmailModule from './verifyEmailModule';

importFilesUnderPath(require.context("./constants/", true, /\.js$/));
importFilesUnderPath(require.context("./services/", true, /\.js$/));
importFilesUnderPath(require.context("./controllers/", true, /\.js$/));
importFilesUnderPath(require.context("./directives/", true, /\.js$/));

let templateContext = require.context("./", true, /\.html$/);
let templates = templateCacheGenerator(angular, 'verifyEmailAppTemplates', templateContext);


const webAppContainer = document.getElementById('verify-email-container') || document.getElementById('verify-email-web-app');
webAppContainer.setAttribute('verify-email-container', '');

//self manual initialization
angular.element(function () {
    angular.bootstrap(webAppContainer, [verifyEmailModule.name, templates.name]);
});

export default verifyEmailModule;